import Lookup from './Lookups.types'

export const brandOwner: SimpleListItem[] = [
	{ id: 1, label: 'Manufacturer' },
	{ id: 2, label: 'Distributor' },
	{ id: 9, label: 'Customer' },
]

export const marketBasketSource: SimpleListItem[] = [
	{ id: 'SWITCH_NOTIFICATION', label: 'Switch Notification' },
	{ id: 'ANALYST', label: 'Analyst' },
]

export const lookupsStatic = {
	[Lookup.BrandOwner]: brandOwner,
	[Lookup.MarketBasketSource]: marketBasketSource,
}
